import { useRouteError } from 'react-router-dom';

const ErrorPage = () => {
    const error = useRouteError();

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Rayos, un extraño error ha ocurrido</p>
            <p>{error.status} {error.statusText || error.message}</p>
        </div>
    );
};

export default ErrorPage;